import { render, staticRenderFns } from "./shpov2.vue?vue&type=template&id=186b4944&scoped=true"
import script from "./shpov2.vue?vue&type=script&lang=js"
export * from "./shpov2.vue?vue&type=script&lang=js"
import style0 from "./shpov2.vue?vue&type=style&index=0&id=186b4944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186b4944",
  null
  
)

export default component.exports